module.exports = __webpack_public_path__ + "static/input-21f2c3746a6b3ec8886b36bbe60fac50.jpg";